const _ = require('lodash');

module.exports = object => _.isEmpty(object);



// WEBPACK FOOTER //
// ./~/unicorn/shared/helpers/empty.js